import Customers from './Customers'
import * as selectors from './customers.selectors'
import * as asyncActions from './customers.asynActions'
import slice from './customers.slice'

export const {
	name,
	actions: { setCustomerFilters, resetAccount },
	reducer,
} = slice

export const { fetchCustomerUsers, fetchCustomers, fetchFFLs } = asyncActions

export const { selectAccounts, selectUsers, selectFfls } = selectors

export default Customers
